import React from 'react';
import { isBrandOV, isMarketGB, isBrandDS, isBrandAP, isBrandAC } from '../../../constants/main';
import { OrderPanelStyledAC } from './AC/OrderPanelStyled.AC';
import { OrderPanelStyledACGB } from './AC/GB/OrderPanelStyled.ACGB';
import { OrderPanelStyledAP } from './AP/OrderPanelStyled.AP';
import { OrderPanelStyledDS } from './DS/OrderPanelStyled.DS';
import { OrderPanelStyledDSGB } from './DS/GB/OrderPanelStyled.DSGB';
import { OrderPanelStyledOV } from './OV/OrderPanelStyled.OV';
import { OrderPanelStyledOV as OrderPanelStyledOV_GB } from './OV/GB/OrderPanelStyled.OV';
import { OrderPanelStyled } from './OrderPanelStyled';
import { SC } from '../../../styles/theme';
import { Pages } from '../../../types/pages';

export interface OrderPanelProps extends SC {
    onContinueClick?: () => void;
    isInvalidConfiguration?: boolean;
    page: Pages;
    onSalesmanClick?: (label?: string) => void;
    onContinueBasketClick?: (label?: string) => void;
    onInfoIconClick?: (label?: string) => void;
    isWide?: boolean;
}

const OrderPanel = (props: OrderPanelProps) => {
    if (isBrandOV) return isMarketGB ? <OrderPanelStyledOV_GB {...props} /> : <OrderPanelStyledOV {...props} />;
    if (isBrandAC) return isMarketGB ? <OrderPanelStyledACGB {...props} /> : <OrderPanelStyledAC {...props} />;
    if (isBrandAP) return <OrderPanelStyledAP {...props} />;
    if (isBrandDS) return isMarketGB ? <OrderPanelStyledDSGB {...props} /> : <OrderPanelStyledDS {...props} />;
    return <OrderPanelStyled {...props} />;
};

export default OrderPanel;
